import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=7f10f627&scoped=true&lang=pug&"
import script from "./Order.vue?vue&type=script&lang=ts&"
export * from "./Order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10f627",
  null
  
)

export default component.exports